import React from "react";
import { useTranslation } from "react-i18next";
import { CheckboxGroup } from "../../common/CheckboxGroup";
import { Days, MealTypes } from "../../../utils/Constants";

export function AvailabilitySection({
  isDaily,
  availableDays,
  mealTypes,
  toggleDay,
  toggleType,
  setField,
}) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {t("mealTypes.title")} <span className="text-red-500">*</span>
        </label>
        <CheckboxGroup
          options={MealTypes}
          selected={mealTypes}
          onToggle={toggleType}
          renderLabel={(type) => type}
        />
        {(!mealTypes || mealTypes.length === 0) && (
          <p className="text-sm text-red-500 mt-1">
            {t("pleaseSelectAtLeastOneMealType")}
          </p>
        )}
      </div>
      {!isDaily && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t("availableDays")}
          </label>
          <CheckboxGroup
            options={Days}
            selected={availableDays}
            onToggle={toggleDay}
            renderLabel={(day) => t(`days.${day}`)}
          />
        </div>
      )}
    </div>
  );
}
